import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a5b2f9e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4a5b2f9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5b2f9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/.jenkins/workspace/crm-ui/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a5b2f9e')) {
      api.createRecord('4a5b2f9e', component.options)
    } else {
      api.reload('4a5b2f9e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4a5b2f9e&scoped=true&", function () {
      api.rerender('4a5b2f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/order/salesOrder/index.vue"
export default component.exports